import React from 'react';
import styled from 'styled-components';

import {buildInteractionIdProps} from '../../../../libs/shared/core/src/helpers/interaction/interactionHelpers';
import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {helpCenterUrl} from '../../../store/stateless/navigationActions';
import {StyledAnalyticsNavigationTitleDiv} from './legacyReportNavigationLinks';
import {ReportNavigationHelpLink} from './reportNavigationHelpLink';

/*
 * Styles.
 */

const StyledNavigationHelpWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 20px;

  &:first-child {
    margin-top: 4px;
  }
`;

/*
 * Component.
 */

const interactionId = 'analytics-support';
const interactionProps = buildInteractionIdProps(interactionId);

const helpLinks = [
  {
    name: <Trans id="analytics-support-glossary">Glossary</Trans>,
    iconName: 'glossaryLineSmall',
    linkUrl: `${helpCenterUrl}/category/analytics-glossary`,
  },
  {
    name: <Trans id="analytics-support-help">Help</Trans>,
    iconName: 'helpSmall',
    linkUrl: `${helpCenterUrl}/t/p8hz4m4/understanding-analytics`,
  },
] as const;

export const ReportNavigationHelpLinks = () => (
  <StyledNavigationHelpWrapper {...interactionProps}>
    <StyledAnalyticsNavigationTitleDiv>
      <Trans id="analytics-support-navigation-title">Resources</Trans>
    </StyledAnalyticsNavigationTitleDiv>
    {helpLinks.map((helpLink) => (
      <ReportNavigationHelpLink
        key={helpLink.iconName}
        iconName={helpLink.iconName}
        name={helpLink.name}
        linkUrl={helpLink.linkUrl}
      />
    ))}
  </StyledNavigationHelpWrapper>
);
